import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { parseLangPath, isPublicPath } from "../lib/i18nRoutes";

// Sincroniza o idioma do i18n com o PREFIXO da URL nas páginas públicas.
// Nas páginas prefixadas (/es, /en) e nas públicas em PT, a URL manda no idioma
// (SEO). Fora das públicas (áreas autenticadas), não força — mantém a escolha
// do usuário/detector.
const LanguageSync = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const { lang, basePath } = parseLangPath(pathname);
    const urlIsAuthoritative = lang !== "pt" || isPublicPath(basePath);
    if (urlIsAuthoritative && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      try {
        localStorage.setItem("i18nextLng", lang);
      } catch {
        /* localStorage indisponível — ignora */
      }
    }
  }, [pathname, i18n]);

  return null;
};

export default LanguageSync;
